export default {
    "message": "Success",
    "status": 200,
    "clientApplications": [
        {
            "applicationStatus": "APPROVAL_REQ",
            "staffUserId": "adil.mohammad",
            "category": "Assigned",
            "application": {
                "client": {
                    "email": "adilbaber@gmail.com",
                    "firstName": "dd",
                    "lastName": "dd",
                    "phoneNumber": "(111) 111-1111"
                }
            },
            "dateReceived": "2021-13-09",
            "applicationId": "0980-618613-2316"
        },
        {
            "applicationStatus": "PROCESSING_APP",
            "staffUserId": "john.vimalraj",
            "category": "Assigned",
            "application": {
                "client": {
                    "email": "gg@eee.nnn",
                    "firstName": "ddd",
                    "lastName": "dd",
                    "phoneNumber": "(111) 111-1111"
                }
            },
            "dateReceived": "2021-24-06",
            "applicationId": "0917-682773-5157"
        },
        {
            "applicationStatus": "INFO_REQ",
            "staffUserId": "john.vimalraj",
            "category": "Assigned",
            "application": {
                "client": {
                    "email": "sumrana.muqtadir@gmail.com",
                    "firstName": "dd",
                    "lastName": "dd",
                    "phoneNumber": "(111) 111-1111"
                }
            },
            "dateReceived": "2021-24-06",
            "applicationId": "0917-625319-5909"
        },
        {
            "category": "Assigned",
            "application": {
                "client": {
                    "email": "ad@gg.ff",
                    "firstName": "dd",
                    "lastName": "dd",
                    "phoneNumber": "(111) 111-1111"
                }
            },
            "applicationStatus": "APPROVAL_REQ_DENIED",
            "dateReceived": "2021-06-05",
            "applicationId": "0912-829186-0818"
        },
        {
            "applicationStatus": "APPROVAL_REQ_APPROVED",
            "staffUserId": "john.vimalraj",
            "category": "Assigned",
            "application": {
                "client": {
                    "email": "pp@pp.pp",
                    "firstName": "dd",
                    "lastName": "dd",
                    "phoneNumber": "(111) 111-1111"
                }
            },
            "dateReceived": "2021-05-05",
            "applicationId": "0912-058936-0468"
        },
        {
            "applicationStatus": "ASSIGNED",
            "staffUserId": "john.vimalraj",
            "category": "Assigned",
            "application": {
                "client": {
                    "email": "johnvimalraj@gmail.com",
                    "firstName": "asfasdf",
                    "lastName": "asdfasd",
                    "phoneNumber": "(111) 111-1111"
                }
            },
            "dateReceived": "2021-15-05",
            "applicationId": "0910-242851-3417"
        }
    ]
}